<template>
  <v-app>
    <CustomToastV2
      v-if="getToastData?.snackbar"
      :snackbar="getToastData?.snackbar"
      :message="getToastData?.message"
      :color="getToastData?.color"
    />
    <ConfirmationDialog
      v-if="getUnsavedChangesDialog?.open"
      card-title="Unsaved Changes"
      card-action-title="Leave Page"
      @confirmation="confirmLeaveWithUnsavedChanges"
      @closeConfirmationDialog="closeUnsavedChangesDialog"
    >
      <template #cardText>
        You have unsaved changes. If you leave this page, your changes will be
        lost.
      </template>
    </ConfirmationDialog>
    <router-view></router-view>
  </v-app>
</template>

<script>
import CustomToastV2 from "@/utilities/components/CustomToastV2";
import ConfirmationDialog from "@/utilities/components/ConfirmationDialog.vue";
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: { CustomToastV2, ConfirmationDialog },
  watch: {
    $route: {
      handler: function (to) {
        document.title = to?.meta?.title
          ? `Razi-Tech | ${to?.meta?.title}`
          : "Razi-Tech";
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["getToastData", "getUnsavedChangesDialog"]),
  },
  methods: {
    closeUnsavedChangesDialog() {
      this.$store.commit("closeUnsavedChangesDialog");
    },
    confirmLeaveWithUnsavedChanges() {
      const pendingRoute = this.getUnsavedChangesDialog?.pendingRoute;
      this.$store.commit("closeUnsavedChangesDialog");
      // user explicitly accepted losing changes
      this.$store.commit("setHasUnsavedChanges", false);
      if (pendingRoute) {
        this.$router.push(pendingRoute).catch(() => {});
      }
    },
  },
};
</script>
